/**
 * Module: app.js
 */
export const APP_ROUTE_LOADING = 'APP_ROUTE_LOADING';

/**
 * Module: plants.js
 */
export const PLANTS_LIST_PENDING = 'PLANTS_LIST_PENDING';
export const PLANTS_LIST_SUCCESS = 'PLANTS_LIST_SUCCESS';
export const PLANTS_LIST_FAILURE = 'PLANTS_LIST_FAILURE';

export const PLANTS_FETCH_PENDING = 'PLANTS_FETCH_PENDING';
export const PLANTS_FETCH_SUCCESS = 'PLANTS_FETCH_SUCCESS';
export const PLANTS_FETCH_FAILURE = 'PLANTS_FETCH_FAILURE';

export const API_KEYS_LIST_PENDING = 'API_KEYS_LIST_PENDING';
export const API_KEYS_LIST_SUCCESS = 'API_KEYS_LIST_SUCCESS';
export const API_KEYS_LIST_FAILURE = 'API_KEYS_LIST_FAILURE';

/**
 * Module: user.js
 */
export const AUTH_SET_LOGIN_RETURN_PATH = 'AUTH_SET_LOGIN_RETURN_PATH';
export const AUTH_USER_LOGIN_PENDING = 'AUTH_USER_LOGIN_PENDING';
export const AUTH_USER_LOGIN_SUCCESS = 'AUTH_USER_LOGIN_SUCCESS';
export const AUTH_USER_LOGIN_FAILURE = 'AUTH_USER_LOGIN_FAILURE';
export const AUTH_USER_REFRESH_TOKEN_SUCCESS =
  'AUTH_USER_REFRESH_TOKEN_SUCCESS';
export const AUTH_USER_REFRESH_TOKEN_FAILURE =
  'AUTH_USER_REFRESH_TOKEN_FAILURE';
export const AUTH_USER_LOGOUT_PENDING = 'AUTH_USER_LOGOUT_PENDING';
export const AUTH_USER_LOGOUT_SUCCESS = 'AUTH_USER_LOGOUT_SUCCESS';
export const AUTH_USER_LOGOUT_FAILURE = 'AUTH_USER_LOGOUT_FAILURE';
export const AUTH_USER_LOGOUT_CLEANUP = 'AUTH_USER_LOGOUT_CLEANUP';
